import { render, staticRenderFns } from "./ClientOrganisation.vue?vue&type=template&id=2d80787f&"
import script from "./ClientOrganisation.vue?vue&type=script&lang=js&"
export * from "./ClientOrganisation.vue?vue&type=script&lang=js&"
import style0 from "./ClientOrganisation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports